import { render, staticRenderFns } from "./SuccesNotice.vue?vue&type=template&id=2aca6934&"
import script from "./SuccesNotice.vue?vue&type=script&lang=js&"
export * from "./SuccesNotice.vue?vue&type=script&lang=js&"
import style0 from "./SuccesNotice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports